export default "__VITE_ASSET__CxjD6io___"